import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Loader from "../components/Loader";
import "../App.css";
import "../css/skin-modes.css";
import "../css/custom.css";

function Terms() {
  const [loading, setLoading] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="page" style={{ visibility: "visible", opacity: 1 }}>
      <div className="page-main is-expanded">
        <Header onToggleSidebar={() => setMobileMenuOpen(o => !o)} />

        <Sidebar
          mobileOpen={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
          active="terms"
        />

        <div className="app-content main-content mt-0">
          <div className="side-app">
            <div className="main-container container-fluid">

              {/* PAGE HEADER */}
              <div className="page-header">
                <div>
                  <h1 className="page-title">Terms</h1>
                </div>

                <div className="ms-auto pageheader-btn">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/wallet">Home</a>
                    </li>

                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                    >
                      Terms
                    </li>
                  </ol>
                </div>
              </div>

              {/* TERMS */}
              <div className="row">
                <div className="col-md-12">
                  <div className="card">

                    <div className="card-header border-bottom">
                      <h3 className="card-title">
                        Terms and Conditions
                      </h3>
                    </div>

                    <div className="card-body">
                      <div>

                        <p>
                          1) Расчеты в магазине автоматические. Мы не несем
                          ответственности за ошибки, вызванные неправильным
                          вводом данных пользователем.
                          <br />

                          2) Возврат неиспользованных средств невозможен,
                          поэтому внимательно проверяйте данные перед
                          пополнением счета.
                          <br />

                          3) Возврат средств за невалидный материал возможен
                          в течение 15 минут после покупки.
                          <br />

                          4) Магазин оставляет за собой право менять правила
                          без предварительного уведомления пользователей.
                          <br />

                          5) Запрещенно создавать и использовать более чем
                          1 аккаунт.
                        </p>

                        <p>
                          1) Calculations in the store are automatic. We are
                          not responsible for errors caused by incorrect user
                          input.
                          <br />

                          2) Refunds for unused funds are not possible, so
                          please check the data carefully before depositing
                          funds.
                          <br />

                          3) Refunds for invalid materials are possible within
                          15 minutes of purchase.
                          <br />

                          4) The store reserves the right to change the rules
                          without prior notification to users.
                          <br />

                          5) Multi-accounting is prohibited on our shop.
                        </p>

                        <hr />

                        <h4 className="mb-3">
                          Refunds and Trust Score
                        </h4>

                        <p>
                          После покупки у Вас есть 24 часа, чтобы открыть
                          полный номер карты. После открытия, у Вас есть
                          15 минут, чтобы подать карту на рефунд.
                        </p>

                        <p>
                          Вам на выбор предоставлено 2 чекера -
                          luxchecker &amp; try2check.
                          <br />

                          Если не удается отправить на реф, это означает что
                          ваш TrustScore слишком низкий. Вот более детальная
                          информация по поводу TrustScore:
                        </p>

                        <p>
                          <strong>
                            trust_score = ((total_spent - total_refunds) /
                            total_spent) * 100
                          </strong>
                        </p>

                        <p>
                          где:
                          <br />
                          <br />

                          total_spent - общая сумма покупок;
                          <br />
                          <br />

                          total_refunds - сумма отправленных на рефунд карт;
                          <br />
                          <br />

                          trust_score - итоговый trust score в процентах.
                        </p>

                        <p>
                          Например, если общая сумма покупок равна 1000
                          долларов, а сумма отправленных на рефунд карт -
                          100 долларов, то trust score можно вычислить
                          следующим образом:
                        </p>

                        <p>
                          <strong>
                            ((1000 - 100) / 1000) * 100 = 90%
                          </strong>
                        </p>

                        <p>
                          Таким образом, trust score в данном случае будет
                          равен 90 процентам.
                        </p>

                        <p>
                          - 10 уровней тотал
                          <br />
                          - Каждый уровень -0.10$ от стоимости карт
                          <br />
                          - +10$ на каждом уровне, начиная с 2
                          (если за поинты покупать деньги не добавляются)
                        </p>

                        <h5>Уровни начисляются за пополнения:</h5>

                        <p>
                          0 уровень - при регистрации (Запрещено делать реф)
                          <br />
                          1 уровень - при пополнении 150$ (Trust 95%, если
                          ниже - запрещено делать реф)
                          <br />
                          2 уровень - при пополнении 350$ (Trust 90%, если
                          ниже - запрещено делать реф)
                          <br />
                          3 уровень - при пополнении 700$ (Trust 85%, если
                          ниже - запрещено делать реф)
                          <br />
                          4 уровень - при пополнении 1200$ (Trust 75%, если
                          ниже - запрещено делать реф)
                          <br />
                          5 уровень - при пополнении 2000$ (Trust 70%, если
                          ниже - запрещено делать реф)
                          <br />
                          6 уровень - при пополнении 5000$ (Trust 68%, если
                          ниже - запрещено делать реф)
                          <br />
                          7 уровень - при пополнении 12000$ (Trust 65%, если
                          ниже - запрещено делать реф)
                          <br />
                          8 уровень - при пополнении 25000$ (Trust 63%, если
                          ниже - запрещено делать реф)
                          <br />
                          9 уровень - при пополнении 35000$ (Trust 61%, если
                          ниже - запрещено делать реф)
                          <br />
                          10 уровень - при пополнении 50000$ покупок
                          (Trust 60%, если ниже - запрещено делать реф)
                        </p>

                        <hr />

                        <h4 className="mb-3">
                          Refunds and Trust Score
                        </h4>

                        <p>
                          After purchase, you have 24 hours to open the card
                          information. Once opened, you have a 15-minute to
                          submit a refund request.
                        </p>

                        <p>
                          There are 2 checker for choice. Luxchecker and
                          try2chek.
                          <br />

                          If the refund fails, it means that your TrustScore
                          is too low. Here is more detailed information about
                          TrustScore:
                        </p>

                        <p>
                          <strong>
                            trust_score = ((total_spent - total_refunds) /
                            total_spent) * 100
                          </strong>
                        </p>

                        <p>
                          so
                          <br />
                          <br />

                          total_spent - total amount of purchases;
                          <br />
                          <br />

                          total_refunds - amount of refunded cards;
                          <br />
                          <br />

                          trust_score - total trust score in percent.
                        </p>

                        <p>
                          For example, if the total amount of purchases is
                          $1,000, and cards sent for a refund in amount of
                          $100, then the trust score can be calculated as
                          follows:
                        </p>

                        <p>
                          <strong>
                            ((1000 - 100) / 1000) * 100 = 90%
                          </strong>
                        </p>

                        <p>
                          Thus, the trust score in this case will be equal to
                          90 percent.
                        </p>

                        <p>
                          - There are 10 levels
                          <br />
                          - Each level -0.10$ from the cost of cards
                          <br />
                          - +10$ at each level starting from level 2
                          (if you buy for points then money is not added)
                        </p>

                        <h5>Levels are awarded for top ups:</h5>

                        <p>
                          Level 0 - after registration (no refund available)
                          <br />
                          Level 1 - after 150$ Top-up (Trust 95%, if lower -
                          no refund available)
                          <br />
                          Level 2 - after 350$ Top-up (Trust 90%, if lower -
                          no refund available)
                          <br />
                          Level 3 - after 700$ Top-up (Trust 85%, if lower -
                          no refund available)
                          <br />
                          Level 4 - after 1200$ Top-up (Trust 75%, if lower -
                          no refund available)
                          <br />
                          Level 5 - after 2000$ Top-up (Trust 70%, if lower -
                          no refund available)
                          <br />
                          Level 6 - after 5000$ Top-up (Trust 68%, if lower -
                          no refund available)
                          <br />
                          Level 7 - after 12000$ Top-up (Trust 65%, if lower -
                          no refund available)
                          <br />
                          Level 8 - after 25000$ Top-up (Trust 63%, if lower -
                          no refund available)
                          <br />
                          Level 9 - after 35000$ Top-up (Trust 61%, if lower -
                          no refund available)
                          <br />
                          Level 10 - after 50000$ Top-up (Trust 60%, if lower -
                          no refund available)
                        </p>

                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* FOOTER */}
        <footer className="footer">
          <div className="container">
            <div className="row align-items-center flex-row-reverse">
              <div className="col-md-12 col-sm-12 text-center">
                Copyright Patrick Market © 2025 All rights reserved
              </div>
            </div>
          </div>
        </footer>

      </div>
    </div>
  );
}

export default Terms;